(
    function (skyward, $, undefined)
    {
        skyward.examples = skyward.examples || {};

        skyward.examples.decimalMin = function (precision, scale)
        {
            return '-' + skyward.examples.decimalMax(precision, scale);
        };

        skyward.examples.decimalMax = function (inPrecision, inScale)
        {
            var precision = parseInt(inPrecision, 10);

            if (isNaN(precision))
            {
                var precisionControl = $(inPrecision);
                if (precisionControl.length > 0)
                {
                    precision = parseInt(skyward.controls.getValue(precisionControl), 10);
                }
            }

            var scale = parseInt(inScale, 10);

            if (isNaN(scale))
            {
                var scaleControl = $(inScale);
                if (scaleControl.length > 0)
                {
                    scale = parseInt(skyward.controls.getValue(scaleControl), 10);
                }
            }

            if (!validDecimalArgs(precision, scale))
            {
                precision = 1;
                scale = 0;
            }

            var example = '';

            for (var i = 0; i < precision - scale; i++)
            {
                example += 9;
            }

            if (scale > 0)
            {
                example += '.';

                for (var j = 0; j < scale; j++)
                {
                    example += 9;
                }
            }

            return formatNumber(example);
        };

        skyward.examples.dateTimeMin = function (precision)
        {
            return '0001-01-01 00:00:00' + addPrecisionDecimals(precision);
        };

        skyward.examples.dateTimeMax = function (input)
        {
            return '9999-12-31 23:59:59' + addPrecisionDecimals(input);
        };

        skyward.examples.timeMin = function (input)
        {
            return '00:00:00' + addPrecisionDecimals(input);
        };

        skyward.examples.timeMax = function (input)
        {
            return '23:59:59' + addPrecisionDecimals(input);
        };

        function validDecimalArgs(precision, scale)
        {
            return (!isNaN(precision) && !isNaN(scale) && precision > 0 && precision < 37 && scale >= 0 && scale <= precision);
        }

        function formatNumber(number)
        {
            if (isNaN(number))
            {
                return '';
            }
            var negative = false;

            if (number < 0)
            {
                negative = true;
                number = (number + '').replace('-', '');
            }

            number = number + '';
            number = number.split('.');

            var placeCount = 1;
            for (var i = number[0].length - 1; i > 0; i--)
            {
                if (placeCount % 3 == 0)
                {
                    number[0] = number[0].substr(0, i) + ',' + number[0].substr(i, number[0].length - i);
                }
                placeCount++;
            }

            number = number.join('.');

            if (negative)
            {
                number = '-' + number;
            }

            return number;
        }

        function addPrecisionDecimals(input)
        {
            var precision = parseInt(input, 10);

            if (isNaN(precision))
            {
                var control = $(input);
                if (control.length > 0)
                {
                    precision = parseInt(skyward.controls.getValue(control), 10);
                }
            }

            if (isNaN(precision) || precision < 0 || precision > 7)
            {
                precision = 1;
            }

            var value = '';
            if (precision > 0)
            {
                value += '.';

                for (var i = 0; i < precision; i++)
                {
                    value += '0';
                }
            }
            return value;
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);